module.exports = __webpack_public_path__ + "img/play-circle.dea14759.png";